<template>
<div class="SellerCenter">
	<div class="main">
		<div class="elbox">
			<el-row>
				<el-col :span="4">
					<div class="left">
						<div class="content">
							<div class="SellerCenter">商家工作台</div>
							<div class="menu">
								<el-menu :default-active="activeItem" @select="handleSelect"
									@open="handleOpen" @close="handleClose">
									<div v-for="(father, i) in menu" :key="i">
										<template v-if="father.menuson">
											<el-submenu :index="father.index" v-if="!father.disabled">
												<template slot="title">
													<i v-show="father.icon" :class="father.icon"></i>
													<i v-show="father.iconOther" class="iconfont"
														v-html="father.iconOther"></i>
													<span>{{ father.name }}</span>
												</template>
												<el-menu-item v-for="(item, i) in father.menuson" :key="i"
													:index="item.index">
													<span slot="title">{{ item.name }}</span>
												</el-menu-item>
											</el-submenu>
										</template>
										<template v-else>
											<el-menu-item v-if="!father.disabled" :index="father.index">
												<i v-show="father.icon" :class="father.icon"></i>
												<i v-show="father.iconOther" class="iconfont"
													v-html="father.iconOther"></i>
												<span slot="title">{{ father.name }}</span>
											</el-menu-item>
										</template>
									</div>
								</el-menu>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="20">
					<div class="right">
						<div class="content">
							<div class="Bread_crumbs flex-align-items">
								<el-breadcrumb separator="/">
									<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
									<el-breadcrumb-item :to="{ path: '/SellerCenter' }">
										商家工作台</el-breadcrumb-item>
									<el-breadcrumb-item v-if="typecomS"
										:to="{ path: '/SellerCenter', query: { type: 'CommodityAdd' } }">
										商品发布</el-breadcrumb-item>
									<el-breadcrumb-item>{{ getcurrentitem }}</el-breadcrumb-item>
								</el-breadcrumb>
							</div>
							<div class="item_com">
								<component :is="activeItem"></component>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</div>
</template>

<script>
import SellerCenter from './SellerCenterManage/index';
import managementStore from './managementStore/index';
import CommodityList from './CommodityList/index';
import CommodityAdd from './CommodityAdd/index';

import BasicData from './CommodityAdd/BasicData';
import DataProducts from './CommodityAdd/DataProducts';
import softwareTool from './CommodityAdd/softwareTool';
import OtherProduct from './CommodityAdd/OtherProduct.vue';
import BulkImport from './CommodityAdd/BulkImport.vue';

import SolutionList from "./SolutionManage/SolutionList";
import SolutionAdd from "./SolutionManage/SolutionAdd";
import TransactionList from './TransactionList/index';
import managementContract from './managementContract/index';
import managementComment from './managementComment/index';


export default {
	name: 'SellerCenter111',
	components: {
		SellerCenter,
		managementStore,
		CommodityList,
		BasicData, DataProducts, softwareTool, OtherProduct, BulkImport,
		CommodityAdd,
		SolutionList, SolutionAdd,
		TransactionList,
		managementContract,
		managementComment
	},
	data() {
		return {
			tableData: [],
			activeItem: 'SellerCenter',
			itemobj: {
				SellerCenter: '卖家中心',
				managementStore: '店铺管理',
				CommodityAdd: '商品发布',
				CommodityList: '商品列表',
				SolutionList: '方案列表',
				SolutionAdd: '发布方案',
				TransactionList: '订单列表',
				managementContract: '合同管理',
				managementComment: '评论管理',
				BasicData: '影像数据',
				DataProducts: '数据产品',
				softwareTool: '软件产品',
				OtherProduct: '其他产品',
				BulkImport: '批量导入'
			},
			menu: [
				{
					index: 'SellerCenter',
					name: '卖家中心',
					iconOther: '&#xe866;',
				},
				{
					index: 'managementStore',
					name: '店铺管理',
					// disabled: this.$store.state.user.userInfo.supplierStatus != 1,
					icon: 'el-icon-s-shop',
				},
				{
					index: 'CommodityList',
					name: '商品管理',
					// disabled: this.$store.state.user.userInfo.shopStatus != 1,
					icon: 'el-icon-shopping-bag-1',
					menuson: [
						{
							index: 'CommodityList',
							name: '商品列表',
						},
						{
							index: 'CommodityAdd',
							name: '商品发布'
						}
					]
				},
				{
					index: 'BasicData',
					disabled: true,
					name: '影像数据'
				}, {
					index: 'DataProducts',
					disabled: true,
					name: '数据产品'
				}, {
					index: 'softwareTool',
					disabled: true,
					name: '软件产品'
				}, {
					index: 'OtherProduct',
					disabled: true,
					name: '其他产品'
				},{
					index: 'BulkImport',
					disabled: true,
					name: '批量导入'
				},
				
				// {
				// 	index: 'SolutionList',
				// 	name: '解决方案',
				
				// 	icon: 'el-icon-s-opportunity',
				// 	menuson: [
				// 		{
				// 			index: 'SolutionList',
				// 			name: '方案列表',
				// 		},
				// 		{
				// 			index: 'SolutionAdd',
				// 			name: '发布方案'
				// 		}
				// 	]
				// },
				{
					index: 'managementTransaction',
					name: '交易管理',
					icon: 'el-icon-data-line',
					// disabled: this.$store.state.user.userInfo.shopStatus != 1,
					menuson: [
						{
							index: 'TransactionList',
							name: '订单列表'
						}
					]
				},
				{
					index: 'managementContract',
					name: '合同管理',
					// disabled: this.$store.state.user.userInfo.supplierStatus != 1,
					icon: 'el-icon-s-check'
				}
				// ,
				// {
				//   index: 'managementComment',
				//   name: '评论管理',
				//   icon: 'el-icon-chat-line-round',
				// }
			],
			scroll: '',
			typecomS: false,
		};
	},
	computed: {
		getcurrentitem() {
			return this.itemobj[this.$route.query.type] ? this.itemobj[this.$route.query.type] : this.itemobj.InvestmentRules
		},
	},
	mounted() {
		console.log(this.$store.state.user)
		//添加滚动监听器
		window.addEventListener('scroll', this.handleScroll)
		// if (this.$store.state.user.userInfo.shopStatus !== 1) {
		// 	this.$message.warning('当前账号暂无商家权限');
		// 	var that = this;
		// 	setTimeout(function () {
		// 		that.$router.push('/');
		// 	}, 2000)
		// }
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	watch: {
		'$route.query.type': {
			immediate: true,
			handler(newValue) {
				if (newValue) {
					if (Object.keys(this.itemobj).includes(newValue)) {
						this.activeItem = newValue
					} else {
						this.redirectRoute()
					}
				} else {
					this.redirectRoute()
				}
				this.tableData = this[this.$route.query.type + '_tableData']

			}
		},
	},
	methods: {
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.currentPage = 1
		},
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
		},
		redirectRoute() {
			this.$router.push({
				name: 'SellerCenter',
				query: {
					type: 'SellerCenter'
				}
			})
		},
		handleScroll() {
			this.scroll = document.documentElement.scrollTop || document.body.scrollTop
		},
		handleOpen(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleSelect(key, keyPath) {
			this.$router.push({
				name: 'SellerCenter',
				query: {
					type: keyPath[keyPath.length - 1]
				}
			})
		},

	},
};
</script>

<style lang="scss" scoped>
.SellerCenter {
	background: #eee;
	height: calc(100vh - 60px);


	.main {
		padding-top: 25px;


		.elbox {
			margin: 0 auto;
			width: 100%;

			.left {
				padding-left: 15px;

				.content {
					width: 100%;
					height: calc(100vh - 110px);
					background: #fff;
					border: 1px solid #dde4ea;

					.menu {
						height: calc(100% - 50px);
						overflow-y: auto;
						scrollbar-width: none;
						/* firefox */
						-ms-overflow-style: none;

						/* IE 10+ */
						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none
						}
					}

					.el-menu {
						border-right: none;

						li.el-menu-item.is-active::before {
							display: inline-block;
							content: '';
							width: 5px;
							height: 15px;
							background: #3867e9;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
						}

						.iconfont {
							margin-right: 5px;
							width: 24px;
							text-align: center;
							font-size: 18px;
							vertical-align: middle;
							display: inline-block;
						}

					}

					.SellerCenter {
						padding-left: 40px;
						height: 50px;
						line-height: 50px;
						font-size: 20px;
						font-weight: bold;
						background: #fff;
					}

					ul.SellerCenter_item {
						overflow: hidden;
					}
				}
			}

			.right {
				padding: 0 1%;
				width: 100%;

				.content {
					height: calc(100vh - 110px);
					width: 100%;
					background: #fff;
					margin: 0 auto;
					border: 1px solid #dde4ea;
					padding: 15px;
					padding-top: 0;
					overflow-y: auto;

					.Bread_crumbs {
						margin-bottom: 10px;
						height: 45px;
						border-bottom: 1px solid #e4e9ee;
						position: sticky;
						top: 0;
						z-index: 999;
						background: #fff;
					}

					.item_com {
						scrollbar-width: none;
						/* firefox */
						-ms-overflow-style: none;
						/* IE 10+ */

						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none
						}
					}


					.title {
						margin-bottom: 10px;
					}

					.Table {
						height: 85%;

						::v-deep td.el-table_1_column_2 div:hover {
							color: #3868e9;
							cursor: pointer;
						}
					}

					.block {
						text-align: end;
					}
				}
			}
		}
	}
}
</style>